import React from 'react';
import { useParams } from "react-router-dom";

// Material UI
import Grid from '@mui/material/Grid';

// Components
import Summary from './summary';
import SearchProducts from './catalogue';

// Hooks
import { CartProvider } from '../../../hooks/orders/CartProvider';

const SalesView = () => {
    const { orderId } = useParams();

    return (
        <CartProvider orderId={orderId}>
            <Grid container spacing={2}>
                <Grid
                    size={{
                        xs: 12,
                        md: 9
                    }}
                >
                    <SearchProducts />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        md: 3,
                        xl: 3
                    }}
                >   
                    <Summary />
                </Grid>
            </Grid>
        </CartProvider>
    );
}

export default SalesView;